import React from 'react';
import { FileTextIcon, ExternalLinkIcon } from 'lucide-react';
export function RulesetLink() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3522">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3523">
        <div className="flex items-center gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-3524">
          <FileTextIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-3525" />
          <div className="flex-1" data-id="element-3526">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3527">
              Full ruleset can be viewed here:
            </p>
            <a href="https://uspsa.org/viewer/2024-SCSA-Rulebook.pdf" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3528">
              https://uspsa.org/viewer/2024-SCSA-Rulebook.pdf
            </a>
          </div>
          <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-3529" />
        </div>
      </div>
    </div>;
}